import React from 'react';
import { useTranslation } from 'react-i18next';

import { PARTNER_CONNECT_HERO_URL } from 'shared/constants/assets';

import './HaatBanner.css';

interface HaatBannerProps {
  /** Called when the primary "Become a partner" CTA is clicked. */
  onStart?: () => void;
}

/**
 * Full-bleed hero banner shown at the very top of the public landing page.
 * The partner photo is the hero background (~2/3 of the viewport) with the
 * logo, headline and CTA overlaid on top. Scoped styles live in HaatBanner.css.
 */
const HaatBanner: React.FC<HaatBannerProps> = ({ onStart }) => {
  const { t } = useTranslation();

  return (
    <section className="haat-banner">
      <div className="hero">
        <img
          className="hero-bg"
          src={PARTNER_CONNECT_HERO_URL}
          alt={t('landingSections.banner.alt.hero') as string}
          loading="eager"
          decoding="async"
        />
        <div className="hero-overlay" />

        <div className="content">
          <h1 className="headline">{t('landingSections.banner.headlineLine1')}</h1>
          <p className="subheadline">{t('landingSections.banner.headlineLine2')}</p>
          <div className="cta-row">
            <button type="button" className="btn-primary" onClick={onStart}>
              {t('landingSections.banner.becomePartner')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HaatBanner;
